A SEEK work type code.

Currently, four codes are defined for the `seekAnz` scheme:

- `Casual` indicates a casual position.
- `ContractTemp` indicates a fixed-length contract position.
- `FullTime` indicates a full-time position.
- `PartTime` indicates a part-time position.

This information allows us to better forecast the performance of the advertisement products.
